import React, { useState } from 'react';
import DatePicker from "react-datepicker";

const DatePicketControl = ( {props , name , changeHandler , valor} ) => {
    
    const [startDate, setStartDate] = useState(new Date());    
    
    return (
      <DatePicker 
            name = {name}
            selected={valor}
            onChange={(date) => {
                setStartDate(date) 
                changeHandler( date , name )
            }}
            dateFormat="dd/MM/yyyy"
            locale="es"
            showYearDropdown
            dateFormatCalendar="MMMM"
            yearDropdownItemNumber={15} 
            scrollableYearDropdown
        />
    );
}

const RadioInputDoble = ({ id , name, label, value, isChecked, handleChange , isChecked2, handleChange2 }) => {
    
    const handleRadioChange = e => {
        const { id } = e.currentTarget;
        console.log('handleRadioChange - ' + id );
        handleChange(e);
    };

    const handleRadioChange2 = e => {  
        const { id } = e.currentTarget;
        console.log('handleRadioChange2 - ' + id );
        handleChange2(e);
    };

    return(
        <div className="ui horizontal segments" style={ {width: '100%' } }>
            
            <div className="ui segment" style={ {width: '10%' } }>
                <label>NO/SI</label>
                <div className="ui toggle checkbox">                     
                    <input
                        type="checkbox"
                        className="custom-radio"
                        id={id}
                        name={name}
                        value={value}
                        checked={isChecked}
                        onChange={handleRadioChange}
                    />
                    <label htmlFor={id}>
                        <span style={ {color: 'white' } }>.</span>
                    </label>
                </div>
            </div>
            
            <div className="ui segment" style={ {width: '80%' } }>
                <label >
                    <span>{label}</span>
                </label>
            </div>
            
            <div className="ui segment" style={ {width: '10%' } } >
                <label>NO/SI</label>
                <div className="ui toggle checkbox" > 
                    <input
                        type="checkbox"
                        className="custom-radio"
                        id={'2_'+id}
                        name={'2_'+name}
                        value={value}
                        checked={isChecked2}
                        onChange={handleRadioChange2}
                    />
                    <label htmlFor={'2_'+id}>
                    <span style={ {color: 'white' } }>.</span>
                    </label>
                   
                </div>
            </div>
        </div>
    );

};

export default RadioInputDoble;
export{
    DatePicketControl
}